<template>
  <div class="offers-list__container">
    <transition-group name="offer-sort" tag="div" class="offers-list">
      <OfferCard
        v-for="offer in offers"
        :key="offer.id"
        :show-earnings="showEarnings"
        :offer="offer"
        :is-loading="isLoading"
        @select-offer="$emit('select-offer', $event)"
      />
    </transition-group>

    <div
      v-if="!hasOffers"
      class="offers-list__empty-text"
    >
      <p class="offers-list__empty-text__title">Не знайдено жодної пропозиції</p>
      <p class="offers-list__empty-text__subtitle">Спробуйте змінити параметри пошуку</p>
    </div>
  </div>
</template>

<script>
import { default as OfferCard } from '../offer-card/index.vue';

export default {
  props: {
    showEarnings: {
      type: Boolean,
      default: false,
    },
    offers: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  components: { OfferCard },
  computed: {
    hasOffers() {
      return this.offers?.length > 0;
    },
  },
};
</script>

<style scoped lang="scss">
.offers-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;

  &__empty-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100px;

    &__title {
      font-size: 16px;
      font-weight: 500;
      margin: 0 0 8px;
    }

    &__subtitle {
      font-size: 14px;
      color: #717680;
      margin: 0;
    }
  }
}

.offer-sort-move {
  transition: transform 0.4s ease;
}

.offer-sort-enter-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.offer-sort-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease;
  position: absolute;
  width: 100%;
}

.offer-sort-enter {
  opacity: 0;
  transform: translateY(-12px);
}

.offer-sort-leave-to {
  opacity: 0;
  transform: translateY(12px);
}
</style>